import React from "react";
import { Flame, Play, Loader2, ShieldCheck } from "lucide-react";
import { formatDuration } from "@/lib/fakeData";
import RetroImage from "./RetroImage";

export default function FreshRips({ tracks, loading, onSelect, title = "Fresh Rips — Just Added to the Swarm" }) {
  return (
    <div data-testid="fresh-rips" className="bevel-in bg-white flex flex-col flex-1 min-h-0 overflow-hidden">
      <div
        className="flex items-center gap-2 px-3 py-1.5 border-b-2 border-[#B89A00]"
        style={{
          background: "linear-gradient(to bottom, #FFF59D 0%, #FFEB3B 100%)",
        }}
      >
        <Flame size={14} className="text-[#BF360C]" />
        <span className="text-[12px] font-bold text-[#3D2E00]">{title}</span>
        <span className="ml-auto text-[10px] text-[#3D2E00] font-mono flex items-center gap-1">
          <ShieldCheck size={10} /> ALL 100% CLEAN · VERIFIED BY LEMONSHIELD™
        </span>
      </div>

      <div className="flex-1 overflow-y-auto xp-scroll p-3">
        {loading ? (
          <div className="flex flex-col items-center justify-center py-12 text-[12px] text-[#555] gap-3">
            <Loader2 size={20} className="animate-spin text-[#003c9e]" />
            Pulling fresh files from 248,392 peers...
          </div>
        ) : tracks.length === 0 ? (
          <div className="text-center text-[12px] text-[#777] py-8">
            No fresh rips right now. Try refreshing.
          </div>
        ) : (
          <div className="grid grid-cols-4 gap-3">
            {tracks.map((t) => (
              <FreshCard key={t.id} track={t} onSelect={onSelect} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

function FreshCard({ track, onSelect }) {
  return (
    <div
      data-testid={`fresh-card-${track.id}`}
      className="bevel-out bg-[#F8F6EE] hover:bg-[#FFF8D4] p-1.5 cursor-pointer transition-colors group"
      onClick={() => onSelect(track)}
    >
      <div className="aspect-square bg-black bevel-in overflow-hidden relative mb-1.5">
        {track.artwork ? (
          <RetroImage
            src={track.artwork}
            alt={track.title}
            className="w-full h-full object-cover"
            wrapperClassName="w-full h-full"
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center text-white">♪</div>
        )}
        <div className="absolute inset-0 bg-black/0 group-hover:bg-black/40 transition-all flex items-center justify-center">
          <div className="opacity-0 group-hover:opacity-100 bevel-out bg-[#FFEB3B] w-10 h-10 rounded-full flex items-center justify-center shadow-lg">
            <Play size={18} className="text-[#3D2E00] ml-0.5" fill="#3D2E00" />
          </div>
        </div>
        <div
          className="absolute top-1 right-1 text-[9px] font-bold px-1.5 py-0.5 flex items-center gap-0.5 bevel-out"
          style={{ background: "linear-gradient(to bottom, #4DBA2C, #1F8020)", color: "white" }}
        >
          <ShieldCheck size={8} />CLEAN
        </div>
      </div>
      <div className="text-[11px] font-bold truncate text-[#003c9e]" title={track.title}>{track.title}</div>
      <div className="text-[10px] truncate text-[#555]" title={track.artist}>{track.artist}</div>
      <div className="text-[9px] text-[#888] flex justify-between mt-0.5 font-mono">
        <span className="truncate">{track.genre || "—"}</span>
        <span>{formatDuration(track.duration_ms)}</span>
      </div>
    </div>
  );
}
